import fileService from '../services/file-service';

import _memoize from 'lodash/memoize';

export const getFileMemo = _memoize(uuid => fileService.getFile(uuid).then(response => URL.createObjectURL(response)));
